
<div>
  <ul class="ztree">
    <yejin-tree-core
      v-for="(node, index) in isMoreTreeData"
      :key="index"
      :checkBoxType="checkBoxType"
      :allOpen="allOpen"
      :beforeClick="beforeClick"
      :checkBox="checkBox"
      :nodeTrigger="nodeTrigger"
      :index="index"
      :tree="node"
      :first="index === 0"
      :last="treeData.length - 1 === index"
      :currentArray="treeData"
      :parentTree="node.parentTree"
      :rootData="treeData"
      :checkBoxCallInit="checkBoxCallInit"
      :checkBoxCall="checkBoxCall"
      :clickNode="clickNode"
      :hiddenLine="hiddenLine"
      :async="async"
      :isAllCheck="isAllCheck"
      :asyncCall="asyncCall"
      :isShowResourceNum="isShowResourceNum"
      :textMaxLength="textMaxLength"
    />
    <div v-if="treeData.length > 3 && !defaultMore" class="flexRow align-center isMore">
      <span class="cursor" @click="isMore = !isMore">
        {{ isMore ? "收起" : "展开" }}
        <van-icon class="icon" :class="{ up: isMore }" name="arrow-down" />
      </span>
    </div>
  </ul>
</div>
